import { Close as CloseIcon } from '@mui/icons-material';
import { Drawer, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useCallback, useRef, useState } from 'react';
import * as React from 'react';

import DeleteAllWarning from '../../../DeleteAllWarning/DeleteAllWarning';
import { Header, Title } from '../../../_mui';

export enum SidebarSizesEnum {
  xs = 'xs',
  // sm = 'sm',
  // md = 'md',
  // lg = 'lg',
  xl = 'xl',
}

interface IProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: (props: { ref: React.MutableRefObject<boolean>; onClose: () => void }) => React.ReactNode;
  isLoading?: boolean;
  size?: SidebarSizesEnum;
}

// styled components are dynamical and must be called outside the sidebar
// to prevent rerendering and save the form changes after the user interaction
const createStyledDrawer = (getWidth: (theme: any) => string) =>
  styled(Drawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
      color: '#212121',
      width: getWidth(theme),
      padding: 48,
      maxWidth: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  }));

const StyledDrawer = {
  [SidebarSizesEnum.xs]: createStyledDrawer((theme) => theme.sass.muiSidebarMaxWidth),
  [SidebarSizesEnum.xl]: createStyledDrawer((theme) => theme.sass.boxSidebarMaxWidthFullHD),
};

export const Sidebar: React.FC<IProps> = ({ open, onClose, title, children, size = SidebarSizesEnum.xs }) => {
  const ref = useRef(false);
  const [showWarning, setShowWarning] = useState(false);

  const handleClose = useCallback(() => {
    ref.current ? setShowWarning(true) : onClose();
  }, [onClose]);

  const handleWarningSubmit = useCallback(() => {
    ref.current = false;
    setShowWarning(false);
    onClose();
  }, [onClose]);

  const handleCancel = useCallback(() => {
    setShowWarning(false);
  }, []);

  const DRW = StyledDrawer[size];

  return (
    <DRW anchor="right" open={open} onClose={handleClose}>
      <Header>
        <Title variant="h6">{title}</Title>
        <IconButton onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Header>
      {showWarning && (
        <DeleteAllWarning
          title="Quit without saving?"
          message="You have unsaved changes. Are you sure you want to exit without saving?"
          submitLabel="Exit without saving"
          cancelLabel="Stay on page"
          onSubmit={handleWarningSubmit}
          onCancel={handleCancel}
        />
      )}
      {children({ ref, onClose })}
    </DRW>
  );
};
